import { MathRandom, isEmptyData } from '../../utils/helper';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearTag, getTagList, setTag } from '../../store/reducers/tag';

const Tags = (props) => {
	const { isUseStore = true, callback } = props;
	const dispatch = useDispatch();
	const { data: tags, loading, selected } = useSelector((state) => state.tag);
	const user = useSelector((store) => store?.user);
	const [selectedTag, setSelectedTag] = useState(null);

	const handleSelect = (value) => {
		if (isUseStore) {
			return dispatch(setTag({ selected: value }));
		}
		if (callback) {
			callback(value);
		}
    return setSelectedTag(value);
	};

	useEffect(() => {
		if (isEmptyData(user?.token)) return;
		dispatch(
			getTagList(),
		);
	}, [user?.token]);

	useEffect(() => {
		dispatch(clearTag());
	}, []);

	const itemsToRender = useMemo(() => {
		if (loading || isEmptyData(tags?.length)) {
			return new Array(6).fill(null);
		}
		return tags;
	}, [tags, loading]);

	return (
		<div className={`w-full mb-4 mx-4 max-w-[91%] ${isEmptyData(tags) && 'hidden'}`}>
			<div className='grid grid-flow-col auto-cols-max overflow-x-auto snap-x snap-mandatory scroll-smooth scroll-px-4 gap-2 hide-scroll'>
				{itemsToRender.map((item, index) => {
					if (loading) {
						return <div key={`skeleton-${index}`} className='snap-start rounded-full bg-[var(--pin-ball)] h-[33px] animate-pulse' style={{ width: `${MathRandom(60, 120)}px` }} />;
					}
					return (
						<div
							key={`tag-${index}`}
							className={`snap-start w-max cursor-pointer rounded-full bg-gray-100 px-3 py-1.5 text-gray-500 ${(selected === item?.value || selectedTag === item?.value) && '!bg-[var(--rose-violet-opacity)] !text-[var(--rose-violet)]'}`}
							onClick={() => handleSelect(selected === item?.value || selectedTag === item?.value ? null : item?.value)}>
							<span className='text-center text-nowrap text-xs'>{item?.label}</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Tags;
